import { c as _c } from "react/compiler-runtime";
import { HotelSearchNoResult } from "@website/accommodation-ui/hotel-search/hotel-search-panel/hotel-search-no-result";
import { HotelSearchPanelPropertiesType } from "@website/accommodation-ui/hotel-search/hotel-search-panel/hotel-search-panel.types";
import { useFetcher } from "@website/fetcher/use-fetcher";
import { useDebounce } from "@website/hooks/debounce";
import { MaterialIcon } from "@website/icons/material";
import pick from "lodash-es/pick";
import { useState } from "react";
export const useDestination = t0 => {
  const $ = _c(33);
  const {
    cityTitleInitialValues,
    searchAutocompleteFetcher,
    searchSuggestion,
    destinationPlaceholder
  } = t0;
  const [destinationQuery, setDestinationQuery] = useState("");
  const [selectedDestination, setSelectedDestination] = useState("");
  const [selectedDestinationItem, setSelectedDestinationItem] = useState(destinationPlaceholder);
  const query = useDebounce(destinationQuery, 250);
  let t1;
  if ($[0] !== query) {
    t1 = ["searchAutocomplete", query];
    $[0] = query;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = Boolean(query);
  let t3;
  if ($[2] !== searchAutocompleteFetcher) {
    t3 = t4 => {
      const {
        queryKey
      } = t4;
      return searchAutocompleteFetcher?.(queryKey[1]);
    };
    $[2] = searchAutocompleteFetcher;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t1 || $[5] !== t2 || $[6] !== t3) {
    t4 = {
      queryKey: t1,
      enabled: t2,
      queryFn: t3
    };
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const {
    isFetching,
    data
  } = useFetcher(t4);
  let t5;
  if ($[8] !== data || $[9] !== isFetching || $[10] !== query || $[11] !== searchSuggestion) {
    t5 = query && data && data.length > 0 ? data : searchSuggestion && !isFetching ? searchSuggestion : [];
    $[8] = data;
    $[9] = isFetching;
    $[10] = query;
    $[11] = searchSuggestion;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  const destinationList = t5;
  let t6;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = value => {
      setDestinationQuery(value);
    };
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  const onChangeDestinationQuery = t6;
  let t7;
  if ($[14] !== destinationList) {
    t7 = destinationList?.map(_temp);
    $[14] = destinationList;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  const destinationListNormalized = t7;
  let t8;
  if ($[16] !== destinationList) {
    t8 = id => {
      setSelectedDestination(id);
      const destinationItem = destinationList.find(destination => `${destination.id}` === `${id}`);
      setDestinationQuery("");
      setSelectedDestinationItem(destinationItem);
    };
    $[16] = destinationList;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  const onSelectDestination = t8;
  let t9;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = item_0 => {
      setSelectedDestination(item_0.id);
      setDestinationQuery("");
      setSelectedDestinationItem(item_0);
    };
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  const onChangeDestination = t9;
  const t10 = selectedDestinationItem?.title || cityTitleInitialValues;
  let t11;
  if ($[19] !== data || $[20] !== destinationQuery || $[21] !== isFetching) {
    t11 = destinationQuery?.length >= 2 && !isFetching && data && data.length === 0 ? <HotelSearchNoResult query={destinationQuery} /> : undefined;
    $[19] = data;
    $[20] = destinationQuery;
    $[21] = isFetching;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] !== destinationList || $[24] !== destinationListNormalized || $[25] !== destinationQuery || $[26] !== isFetching || $[27] !== onSelectDestination || $[28] !== selectedDestination || $[29] !== selectedDestinationItem || $[30] !== t10 || $[31] !== t11) {
    t12 = {
      selectedDestinationItem,
      selectedDestinationText: t10,
      destinationQuery,
      selectedDestination,
      onChangeDestination,
      onSelectDestination,
      onChangeDestinationQuery,
      destinationList,
      destinationLoading: isFetching,
      destinationListNormalized,
      DestinationNoResult: t11
    };
    $[23] = destinationList;
    $[24] = destinationListNormalized;
    $[25] = destinationQuery;
    $[26] = isFetching;
    $[27] = onSelectDestination;
    $[28] = selectedDestination;
    $[29] = selectedDestinationItem;
    $[30] = t10;
    $[31] = t11;
    $[32] = t12;
  } else {
    t12 = $[32];
  }
  return t12;
};
function _temp(item) {
  return {
    ...pick(item, ["id", "title", "subtitle"]),
    StartIcon: item.isHotel ? <MaterialIcon name="hotel" variant="outlined" /> : <MaterialIcon name="trip_origin" variant="outlined" />,
    Meta: <div className="text-on-surface-high-emphasis text-caption">{item.info}</div>
  };
}